import { render, staticRenderFns } from "./ExcelDetails.vue?vue&type=template&id=66a51078"
import script from "./ExcelDetails.vue?vue&type=script&lang=js"
export * from "./ExcelDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports